<template>
    <div class="container">
        <div class="operate_row">
            <div class="">
            </div>
            <div class="">
                <i class="el-icon-refresh"  @click="getList(1)"></i>
                <el-button type="danger" size="mini" @click="centerDialogVisible=!centerDialogVisible;type=2">新增</el-button>
            </div>
        </div>
        <div class="table_path">
            <el-table :data="list" style="width: 100%" border height="100%" size="mini" header-cell-class-name="list_table_th">
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <div class="icon_wrap">
                            <i class="operation_edit" @click="edit(scope.row.id)" title="修改"></i>
                            <i class="operation_delete" @click="del(scope.row.id)" title="删除"></i>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="港口" prop="name"></el-table-column>
                <el-table-column label="状态">
                     <template slot-scope="scope">
                        <div :class="scope.row.status==1?'setBaseBtnStatus':'setBaseBtnStatusProhibit'" @click="changeStatus(scope.row.id,scope.row.status)">{{scope.row.status_label}}</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog v-dialog-drag :title=" type == 2 ? '新增港口' : '修改港口'" :visible.sync="centerDialogVisible" width="400px" class="eldialog eldialogOneLabel" :model="false">
            <div class="">
                <el-form>
                    <el-form-item label="港口：" prop="name">
                        <el-input class="edit_input" v-model="data.name" placeholder=""></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn"  @click="add">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="centerDialogVisible = false">取消</el-button>
            </div>
		</el-dialog>
    </div>
</template>
<style scoped lang="scss">
    .container{
        padding: 15px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2;
        .operate_row{
            display: flex; align-items: center; justify-content: space-between; padding: 28px 0 8px;
            // .excel_btn{
            //     color: #8A8A8A; cursor: pointer;
            //     & + .excel_btn{ margin-left: 10px; }
            // }
        }
        .table_path{ flex: 1; }
    }
</style>
<script>
    export default {
        data(){
            return{
                params:{
                    keyword: "",
                    belong: "",
                    project: "",
                    per_page: 20
                },
                data:{
                    name:"",
                    id:""
                },
                list:[],
                type:2,//2.新增 3.修改
                centerDialogVisible:false
            }
        },
        created(){
            this.getList()
        },
        methods:{
            changeStatus(id,status){
                if(status==1){
                    status=0
                }else{
                    status=1
                }
                this.postFunc("/erp/port.status",{id:id,status:status},()=>{
                    this.tip("修改成功","success")
                    this.getList()
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            edit(id){
                this.type=3;
                let list=JSON.parse(JSON.stringify(this.list));
                list.forEach(item=>{
                    if(item.id==id){
                        this.data=item;
                    }
                })
                this.centerDialogVisible=true;
            },
            del(id){
                 this.$confirm('是否删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
                    this.postFunc("/erp/port.delete",{id:id},()=>{
                        this.getList()
                        this.tip("删除成功","success")
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            getList(showMessage){
                this.postFunc("erp/port.list",{},res=>{
                    this.list=res.data.data;
                    if(showMessage){
                        this.tip("刷新成功","success")
                    }
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            add(){
                let url="";
                if(this.type==2){
                    url="/erp/port.create"
                }else{
                    url="/erp/port.update"
                }
                this.postFunc(url,this.data,()=>{
                    this.centerDialogVisible=false;
                    if(this.type==2){
                        this.tip("添加成功","success")
                    }else{
                        this.tip("修改成功","success")
                    }
                    this.getList()
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            }
        },
        watch:{
            centerDialogVisible:function(val){
                if(!val){
                    this.data = this.resetJson(this.data)
                }
            }
        }
    }
</script>

